import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DashboardTodolistsResponse as SchemaDashboardTodolistsResponse } from '../schemas/DashboardTodolistsResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Returns todolists with items and completion status
 * @tags Dashboard
 * @summary Get todolists for store setup
 */
export const GetDashboardTodolistsContentType = '' as const;
export type GetDashboardTodolistsRequest = void;
export type GetDashboardTodolistsResponses = LinkCommonErrorResponses & {
    /**
     * @description Todolists
     */
    '200': {
        'application/json': SchemaDashboardTodolistsResponse;
    };
};
export type GetDashboardTodolistsResponseSuccess = GetDashboardTodolistsResponses['200']['application/json'];
export type GetDashboardTodolistsSearchParams = undefined;
export type GetDashboardTodolistsPathParameters = undefined;
export const GetDashboardTodolistsUrl = '/dashboard/todolists' as const;
export const GetDashboardTodolistsMethod = 'GET' as const;
export const getGetDashboardTodolistsUrl = (_params?: GetDashboardTodolistsPathParameters) => GetDashboardTodolistsUrl;
